import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';



const DialogAppOnly = ({ open, dialogTitle, app, setApp, version, setVersion, handleClose }) => {

    function handleApp(e) {
        setApp(e.target.value);
    }

    function handleVersion(e) {
        setVersion(e.target.value);
    }

  return (
  	<Dialog open={open} onClose={handleClose} maxWidth ='md' fullWidth>
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            id="name"
            label="App"
            fullWidth
            variant="standard"
            value={app}
            onChange={handleApp}
          />
          <TextField
            margin="dense"
            id="name"
            label="Version"
            fullWidth
            variant="standard"
            value={version}
            onChange={handleVersion}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Save</Button>
        </DialogActions>
     </Dialog>
  );
}

export default DialogAppOnly;
